import { IBusinessPriority, IBusinessPriorityForm } from '../model/types'

interface IGetInitialBusinessPriorityFormParams {
  isWorldwide: boolean
  market?: string
  initialData?: IBusinessPriority
  /** Available market short codes; worldwide create preselects all of them. */
  marketOptions: string[]
}

/**
 * Builds the initial form values for both variants.
 *
 * - Edit (initialData present): always initialise from the target record.
 * - Worldwide create: preselect all markets.
 * - Market create: preselect the current market.
 *
 * Program offerings start empty on create; status defaults to Draft.
 */
export const getInitialBusinessPriorityForm = ({
  isWorldwide,
  market,
  initialData,
  marketOptions = [],
}: IGetInitialBusinessPriorityFormParams): IBusinessPriorityForm => {
  if (initialData) {
    const { uid, name, description, status, markets, programOfferings } = initialData

    return { uid, name, description, status, markets, programOfferings }
  }

  return {
    name: '',
    description: '',
    status: 'Draft',
    programOfferings: [],
    markets: isWorldwide ? [...marketOptions] : market ? [market] : [],
  }
}
